import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, computed, inject, OnInit, signal, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, firstValueFrom, map, Subject, takeUntil, throwError } from 'rxjs';
import SignaturePad from 'signature_pad';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { VademecumActivity } from 'src/app/models/usuarios/vademecum-activity';
import { ProductosApiService } from 'src/app/service/api/productos-api';
import { UserActivityApiService } from 'src/app/service/api/user_activity-api.service';
import { environment } from 'src/environments/environment';
import packageJson from '../../../../../package.json';
import { ItemInterface, InputType, TypeAheadInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { list } from 'src/app/common/classes/request-builder';
import { NavigationService } from 'src/app/service/navigation.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { ClienteModel } from 'src/app/models/cliente.model';
import { ClientesApiService } from 'src/app/service/api/clientes-api.service';
import { Filtering } from 'src/app/service/filtering/filtering';
import { LoginApiService } from 'src/app/service/api/login-api.service';
import { MessageService } from 'primeng/api';
import moment from 'moment';
import { UploadApiService } from 'src/app/service/api/upload-api.service';


@Component({
  selector: 'app-navbar',
  standalone: false,
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {

  @ViewChild('signaturePadElement', { static: true })
  signaturePadElement!: SignaturePad;
  
  public logoUrl = environment.features.hasHorizontalLogo ?
        environment.logoUrl.replace(/(\.[a-z]+)$/, '_horizontal$1') :
        environment.logoUrl;

  public subscriptionStatusMessage = '';
  
  public subscriptionType = 'demo';

  readonly client_environment = environment;

  readonly productosApi = inject(ProductosApiService);

  readonly router = inject(Router);

  navigationService = inject(NavigationService);

  bo = inject(BreakpointObserver);

  readonly dashboardService = inject(DashboardService);

  private readonly loginService = inject(LoginApiService);

  private readonly clientsService = inject(ClientesApiService);

  private readonly http = inject(HttpClient);

  private readonly userActivityApi = inject(UserActivityApiService);

  private readonly destroy$ = new Subject<void>();

  private readonly messageService = inject(MessageService);

  private readonly uploadApi = inject(UploadApiService);


  title = signal<string>('');

  hasSignature = signal<boolean>(false);

  actualizando = signal<boolean>(false);

  showClientProfile = signal(false);

  showModalProfile = computed(() => this.showClientProfile());

  showAdvertisingForm = false;

  showBackupDialog = false;

  showClientDialog = false;

  showVademecumActivity = false;

  showVademecumListadoProductos = false;

  showVademecumListadoDialog = false;

  showVademecumDialog = false;

  showUsuariosFirma = environment.features.showUsuariosFirma;

  showUsuariosLogs = environment.features.showUsuariosLogs;

  fechaEdited = false;

  isComunero = false;

  auxContador = 0;

  iconRefresh = 'fa fa-refresh';

  modelSignature = signal<string>('');

  textHeaderDialogClient = '';

  validationErrors = '';

  displayWizard = environment.features.welcomeWizard && StorageManager.getUser().wizard_done === 0;

  currentClient = StorageManager.getClient();

  userCanSeeClientes = environment.features.userCanSeeClientes
    ? true
    : StorageManager.getUser().rol === 'admin' ||
    StorageManager.getUser().rol === 'responsable';

  currentUser = StorageManager.getUser();

  urlSignature = environment.serverUrl + 'firmas_usuarios/' + (StorageManager.getUser().id || 0) + '.png';

  fincas = list(['...', null]);

  clients: TypeAheadInterface<ClienteModel> = {
    selected: null,
    filtered: [{ label: 'Cargando...', value: null }],
    values: [],
  };

  labelBtnClient = '';

  unidades = list('Hectáreas', 'Hanegadas', 'Taullas');

  listadoProductos: {
    id?: null | string;
    referencias?: string;
    productos?: string[];
  } = {
      id: null,
      referencias: '',
      productos: [''],
    };

  userActivity: VademecumActivity[] = [];

  helpMenuItems = [
    {
      label: 'Asistente de Bienvenida',
      icon: 'fa fa-help',
      command: (): void => {
        this.displayWizard = true;
      },
    },
    {
      label: 'Guía de la Autorización a Locatec',
      icon: 'fa fa-file',
      command: (): void => {
        window.open(
          'https://locatec.es/proyectos/fitogest/documentos_consulta/guia-subida-autorizacion.pdf',
          '_blank'
        );
      }
    },
  ];

  menuItems = [
    {
      label: 'Mi perfil',
      icon: 'fa fa-user',
      command: (): void => {
        console.log('click');
        
        this.showClientProfile.set(true);
        if (this.showUsuariosFirma) {
          this.fetchSignature();
        }
      },
      visible:
        !!((environment.features.showPerfil && this.currentUser.rol === 'admin') ||
          environment.appName === 'agrogestSIEX' ||
          environment.features.applicationType === 'cropgest'),
    },

    {
      separator: true,
      visible: environment.features.showPerfil && this.currentUser.rol === 'admin',
    },

    {
      label: 'Consulta logs',
      icon: 'fa fa-file',
      command: (): void => {
        this.router.navigate(['/dashboard/colsultas-logs']);
      },
      visible: environment.features.showUsuariosLogs,
    },

    {
      label: 'Publicidad',
      icon: 'fa fa-paper-plane',
      command: (): void => {
        this.showAdvertisingForm = true;
      },
      visible: this.currentUser.rol === 'admin' && environment.appName === 'agroleza',
    },
    {
      label:
        environment.features.applicationType === 'cropgest'
          ? 'Descargar datos'
          : 'Copia de seguridad',
      icon: 'fa fa-download',
      command: (): void => {
        this.showBackupDialog = true;
      },
      visible:
        environment.features.showBackup &&
        ((environment.features.applicationType !== 'cropgest' &&
          this.currentUser.rol === 'admin') ||
          (environment.features.applicationType === 'cropgest' &&
            this.currentUser.tipo === 'comunero')),
    },
    {
      label: 'Sincronizar datos',
      icon: this.iconRefresh,
      command: (): void => {
        this.initSyncDataCoop();
      },
      visible: environment.appName === 'almassora',
    },
    {
      separator: true,
      visible: environment.features.showBackup && this.currentUser.rol === 'admin',
    },
    {
      label: 'Actividad',
      icon: 'fa fa-list-alt',
      command: (): void => {
        this.showVademecumDialog = true;
        this.getVademecumActivity();
      },
      visible: this.showVademecumActivity && this.currentUser.rol === 'admin',
    },
    {
      separator: true,
      visible: this.showVademecumActivity && this.currentUser.rol === 'admin',
    },
    {
      label: 'Mis productos',
      icon: 'fa fa-flask',
      command: (): void => {
        this.productosApi.listadoVademecum.GET.response((res) => {
          if ((res?.[0]?.id) != null) {
            this.listadoProductos = res[0];
            this.listadoProductos.productos = (res[0].referencias ?? '').split(
              ';'
            );
          }
        });
        this.productosApi.listadoVademecum.GET.safePerform({
          id_usuario: StorageManager.getUser().id,
        } as never);
        this.showVademecumListadoDialog = true;
      },
      visible:
        this.showVademecumListadoProductos && this.currentUser.rol === 'admin',
    },
    {
      separator: true,
      visible:
        this.showVademecumListadoProductos && this.currentUser.rol === 'admin',
    },
    {
      label: 'Cerrar sesión',
      icon: 'fa fa-sign-out',
      command: (): void => {
        StorageManager.deleteUser();
        StorageManager.deleteClient();
        this.router.navigate(['login']);
      },
    },
    {
      label: `Version: ${packageJson.version}`,
      icon: 'fa fa-code-fork',
    },
  ];

  formFields: ItemInterface<object>[] = [
    {
      label: 'Nombre/Razón social',
      field: 'nombre',
      inputType: { type: InputType.EDIT_TEXT },
    },
    {
      label: 'Apellidos',
      field: 'apellidos',
      inputType: { type: InputType.EDIT_TEXT },
    },
    {
      label: 'Teléfono',
      field: 'telefono',
      inputType: { type: InputType.EDIT_TEXT },
      visible: environment.appName === 'agrogestSIEX',
    },
    {
      label: 'Tipo de carnet',
      field: 'tipo_carnet',
      inputType: { type: InputType.DROPDOWN },
      values: list(
        ['...', null],
        'BÁSICO',
        'CUALIFICADO',
        'FUMIGADOR',
        'PILOTO',
        'ASESOR'
      ),
      visible: environment.appName !== 'agrogestSIEX',
    },
    {
      label: 'Fecha de caducidad',
      field: 'fecha_caducidad',
      inputType: { type: InputType.CALENDAR },
      visible: environment.appName !== 'agrogestSIEX',
    },
    {
      label: 'CIF/NIF',
      field: 'nif',
      inputType: { type: InputType.EDIT_TEXT },
    },
    {
      label: 'ROPO',
      field: 'ropo',
      inputType: { type: InputType.EDIT_TEXT },
      visible: environment.appName !== 'agrogestSIEX',
    },
    {
      label: 'IMEI',
      field: 'imei',
      inputType: { type: InputType.EDIT_TEXT },
      visible: environment.appName === 'manezylozano',
    },
    {
      label: 'Tipo de mando',
      field: 'tipo_mando',
      inputType: { type: InputType.DROPDOWN },
      values: list(
        ['...', null],
        'SISTRONIC',
        'TRONIC',
        'SISTROMATIC',
        'OZONO'
      ),
      visible: environment.appName === 'manezylozano',
    },
  ];

  formFields2: ItemInterface<object>[] = [
    {
      label: 'Unidad de medida',
      field: 'uds_medida',
      inputType: { type: InputType.DROPDOWN },
      values: this.unidades,
      visible: environment.features.showPerfilUnidades,
    },
    {
      label: 'Relación con una Hectáreas',
      field: 'ratio_ha',
      inputType: { type: InputType.EDIT_NUMERIC },
      placeholder: '1 Hectáreas = X unidades',
      visible: environment.features.showPerfilUnidades,
    },
    {
      label: 'Finca asociada',
      field: 'id_finca',
      valuePrimaryKey: 'id',
      inputType: { type: InputType.DROPDOWN },
      values: this.fincas,
      visible: environment.features.showPerfilFincas,
    },
  ];

  formClient: ItemInterface<object>[] = [
    {
      label: 'Nombre/Razón social',
      field: 'nombre',
      inputType: { type: InputType.EDIT_TEXT },
    },
    {
      label: 'Apellidos',
      field: 'apellidos',
      inputType: { type: InputType.EDIT_TEXT },
    },
    {
      label: 'Dirección',
      field: 'direccion',
      inputType: { type: InputType.EDIT_TEXT },
    },
    {
      label: 'Código postal',
      field: 'codigo_postal',
      inputType: { type: InputType.EDIT_NUMERIC },
    },
    {
      label: 'Población',
      field: 'localidad',
      inputType: { type: InputType.EDIT_TEXT },
    },
    {
      label: 'Provincia',
      field: 'provincia',
      inputType: { type: InputType.EDIT_TEXT },
    },
    {
      label: 'Telefono',
      field: 'telefono',
      inputType: { type: InputType.EDIT_NUMERIC },
    },
    {
      label: 'CIF/NIF',
      field: 'nif',
      inputType: { type: InputType.EDIT_TEXT },
    },
    {
      label: 'ROPO',
      field: 'ropo',
      inputType: { type: InputType.EDIT_TEXT },
    },
  ];

  constructor() {
    // Observa cambios en los breakpoints y actualiza el servicio.
    this.bo.observe([
      Breakpoints.Handset,
      Breakpoints.HandsetPortrait,
      Breakpoints.HandsetLandscape
    ]).subscribe(state => {
      this.navigationService.isMobile.set(state.matches);
      this.navigationService.sidebarCollapsed.set(false);
      console.log('Maches [Mobile]:', state.matches);
      
    });

    this.bo.observe([
      Breakpoints.Tablet,
      Breakpoints.TabletPortrait,
      Breakpoints.TabletLandscape
    ]).subscribe(state => {
      this.navigationService.isTablet.set(state.matches);
      this.navigationService.sidebarCollapsed.set(false);
      console.log('Maches [Tablet]:', state.matches);
    });

    this.bo.observe([
      Breakpoints.Web,
      Breakpoints.WebLandscape,
      Breakpoints.WebPortrait
    ]).subscribe(state => {
      this.navigationService.isDesktop.set(state.matches);
      console.log('Maches [Desktop]:', state.matches);
    });

    this.bo.observe([
      Breakpoints.Handset,
      Breakpoints.HandsetPortrait,
      Breakpoints.HandsetLandscape,
      Breakpoints.Tablet,
      Breakpoints.TabletPortrait,
      Breakpoints.TabletLandscape
    ]).subscribe(state => {
      this.navigationService.isMobileOrTablet.set(state.matches);
      this.navigationService.sidebarCollapsed.set(false);
    });
  }


  ngOnInit(): void {
    if (environment.appName === 'agrogestSIEX') {
      this.daysUntilSubscriptionExpires();
    }
    this.initClients();

    this.dashboardService.onChangeClient()
      .pipe(takeUntil(this.destroy$))
      .subscribe((): void => {
        this.clients.selected = StorageManager.getClient();
        this.initClients();
      });

    this.dashboardService.onDialogChanges()
      .pipe(takeUntil(this.destroy$))
      .subscribe((open: boolean): void => {
        if (open) {
          this.showClientDialog = true;
        } else {
          this.showClientDialog = false;
        }
      });

    this.dashboardService.onProfileChanges()
      .pipe(takeUntil(this.destroy$))
      .subscribe((open: boolean): void => {
        if (open) {
          this.showClientProfile.set(true);
        } else {
          this.showClientProfile.set(false);
        }
      });

    if (environment.features.hasClients) {
      if (!(Boolean(StorageManager.getClient()))) {
        this.showClientDialog = environment.appName !== 'gruesnadal';
      }
    }

    if (environment.appName === 'gruesnadal') {
      const tablasMaestras = this.getModuleItem();
      
      tablasMaestras.forEach((tabla: any) => this.menuItems.push(tabla));
    }
  }

  toogleSidebar(): void {
    this.navigationService.sidebarCollapsed.set(!this.navigationService.sidebarCollapsed());
  }

  scrollToTop(): void {
    const elements = document.getElementsByClassName(
      'ui-dialog-content ui-widget-content'
    );

    const SCROLL_DELAY = 100;

    if (elements?.[0]) {
      setTimeout(() => {
        if (elements[0]) {
          elements[0].scrollTop = 0;
        }
      }, SCROLL_DELAY);
    }
  }

  showSignature(): void {
    const myWindow = window.open(
      'about:blank',
      '_blank',
      'width=600, height=600'
    );

    myWindow?.location.assign(
      environment.serverUrl + 'firmas_asesor/' + this.currentUser.firma
    );
    myWindow?.focus();
  }

  updateClient(): void {
    StorageManager.saveClient(this.clients.selected);
    this.dashboardService.emitClientChange();
  }

  drawComplete(sigpad: SignaturePad): void {    
    this.modelSignature.set(sigpad.toDataURL('image/png'));
  }

  clearSigPad(): void {
    this.modelSignature.set('');
  }

  formChanges(tag: string): void {
    if (tag === 'uds_medida' && this.currentUser.uds_medida === 'Hectáreas') {
      this.currentUser.ratio_ha = 1;
    }

    if (tag === 'fecha_caducidad') {
      this.fechaEdited = true;
    }
  }

  validateForm(): boolean {
    this.validationErrors = '';

    // Sólo aplicar si el usuario tiene el campo `uds_medida` activo.
    if (environment.features.showPerfilUnidades) {
      if (
        this.currentUser.uds_medida !== 'Hectáreas' &&
        (this.currentUser.ratio_ha == null)
      ) {
        this.validationErrors +=
          '\n- Debe especificar la proporción de ' +
          this.currentUser.uds_medida +
          ' respecto a una Hectáreas.';
        return false;
      }
    }

    return true;
  }

  saveProfileEdit(): void {
    if (!this.validateForm()) {
      alert(this.validationErrors);
      return;
    }

    this.actualizando.set(true);

    const headers = new HttpHeaders();

    headers.append('Content-Type:', 'application/json');
    headers.append('Request-Method', 'PUT');

    if (this.isComunero) {
      delete this.currentClient.tipo_carnet;

      firstValueFrom(
        this.http.put(
          `${environment.serverUrl}ws/index.php?p1=generic&p2=clientes&p3=${this.currentUser.id}`,
          JSON.stringify(this.currentClient),
          { headers: headers }
        )
      )
        .then(() => {
          StorageManager.saveClient(this.currentClient);
          this.actualizando.set(false);
          this.showClientProfile.set(false);
          this.showSuccess();
          return;
        })
        .catch((e) => {
          console.log('catch en getPosition: ' + e);
        });
    } else {
      if (this.fechaEdited) {
        this.currentUser.fecha_caducidad = moment(
          this.currentUser.fecha_caducidad
        ).format('DD/MM/YYYY');
        this.fechaEdited = false;
      }

      delete this.currentUser['password'];

      firstValueFrom(
        this.http.put(
          `${environment.serverUrl}ws/index.php?p1=generic&p2=usuarios&p3=${this.currentUser.id}`,
          JSON.stringify(this.currentUser),
          { headers: headers }
        )
      )
        .then(() => {
          StorageManager.saveUser(this.currentUser);
          this.actualizando.set(false);
          this.showClientProfile.set(false);
          this.showSuccess();
          return;
        })
        .then(() => {
          if (this.showUsuariosFirma) {
            this.uploadApi.firmasPOST.toPromise({
              id: StorageManager.getUser().id,
              dir: 'firmas_usuarios',
              firma: this.modelSignature(),
            });
          }
          return;
        })
        .catch((e) => {
          console.log('catch en getPosition: ' + e);
        });
    }
  }

  showSuccess(): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Perfil actualizado',
      detail: 'Se ha actualizado su perfil con éxito.',
    });
  }

  private daysUntilSubscriptionExpires(): void {
    const username = StorageManager.getUser().username ?? '';
     
    const subscriptionStatus = this.http
      .get<{ data: { tipo_suscripcion: string; subscription_status: string } }>(
        environment.serverUrl + 'ws/index.php?p1=user&p2=checkSubscriptionStatus',
        { params: { username } }
      )
      .pipe(
        map(response => ({
          remainingDays: response.data.subscription_status,
          tipo: response.data.tipo_suscripcion
        })),
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );

    subscriptionStatus.subscribe(({ remainingDays, tipo }) => {
      this.subscriptionType = tipo;
      
      if (tipo !== null && tipo === 'demo') {
        if (remainingDays === 'expired') {
          this.subscriptionStatusMessage = 'El periodo de prueba ha expirado.';
        } else {
          this.subscriptionStatusMessage = 'El periodo de prueba termina en ' + remainingDays;
        }
      } else {
        if (remainingDays === 'expired') {
          this.subscriptionStatusMessage = 'La suscripción ha sido cancelada.';
        } else {
          this.subscriptionStatusMessage = 'La suscripción se renovará en ' + remainingDays;
        }
      }
    });

  }


  private async fetchSignature(): Promise<void> {
    const resSignature = await fetch(this.urlSignature);
    const CORRECT_STATUS = 200;

    if (resSignature.status === CORRECT_STATUS) {
      this.hasSignature.set(true);
      const resBlob = await resSignature.blob();
      const urlCreator = window.URL;

      this.signaturePadElement?.fromDataURL(
        urlCreator.createObjectURL(resBlob)
      );
    }
    return;
  }

  private initClients(): void {
     if (
        StorageManager.getClient() !== null ||
        StorageManager.getClient() !== undefined
      ) {
        this.clients.selected = StorageManager.getClient();
      }

      const user = StorageManager.getUser();

      if (user.tipo === 'comunero' && !(Boolean(StorageManager.getClient()))) {
        this.clientsService.clientesGET
          .toPromise({ p3: user.id_cliente } as never)
          .then((cliente) => {
            if (cliente[0]) {
              const c = cliente[0];

              c.id_usuario = user.id;
              this.clients.selected = c;
              this.updateClient();
            }
            return;
          })
          .catch((e) => {
            console.error('catch en getPosition: ' + e);
          });
      } else {
        this.clientsService.clientesGET.response((value) => {
          if (value !== null) {
            if (
              user.rol === 'admin' ||
              user.rol === 'responsable' ||
              environment.features.clientesMostrarTodosDefault
            ) {
              this.clients.filtered = value
                .filter((it: ClienteModel) => it)
                .map((it: ClienteModel) => ({
                  label:
                    (it.razon_social !== undefined && it.razon_social !== null && it.razon_social !== '') ? it.razon_social :
                    it.nombre +
                    (it.apellidos != null ? ' ' + it.apellidos : '') +
                    (it.apellido_1 != null ? ' ' + it.apellido_1 : '') +
                    (it.apellido_2 != null ? ' ' + it.apellido_2 : ''),
                  value: it,
                }))
                .sort(Filtering.sort('label', 1));
            } else {
              if (environment.appName === 'innovia') {
                this.clients.filtered = value
                  .filter((it: ClienteModel) => it)
                  .filter((it: ClienteModel) => [it.id].includes(user.id_cliente ?? ''))
                  .map((it: ClienteModel) => ({
                    label:
                      (it.razon_social !== undefined && it.razon_social !== null && it.razon_social !== '') ? it.razon_social :
                      it.nombre +
                      (it.apellidos != null ? ' ' + it.apellidos : '') +
                      (it.apellido_1 != null ? ' ' + it.apellido_1 : '') +
                      (it.apellido_2 != null ? ' ' + it.apellido_2 : ''),
                    value: it,
                  }))
                  .sort(Filtering.sort('label', 1));
              } else {
                this.clients.filtered = value
                  .filter((it: ClienteModel) => it)
                  .filter((it: ClienteModel) =>
                    [it.id_usuario_asignado, it.id_usuario_asignado2].includes(
                      user.id
                    )
                  )
                  .map((it: ClienteModel) => ({
                    label:
                      (it.razon_social !== undefined && it.razon_social !== null && it.razon_social !== '') ? it.razon_social :
                      it.nombre +
                      (it.apellidos != null ? ' ' + it.apellidos : '') +
                      (it.apellido_1 != null ? ' ' + it.apellido_1 : '') +
                      (it.apellido_2 != null ? ' ' + it.apellido_2 : ''),
                    value: it,
                  }))
                  .sort(Filtering.sort('label', 1));
              }
            }
            if (
              StorageManager.getUser().rol.localeCompare('user') === 0 &&
              (environment.appName.localeCompare('pascualcabedo') === 0 ||
                environment.appName.localeCompare('innovia') === 0)
            ) {
              this.showClientDialog = false;
            } else {
              this.clients.filtered.unshift({
                label: (environment.appName === 'detorres' ? 'TODAS LAS ' : 'TODOS LOS ') + 
                environment.features.clientesName.toUpperCase(),
                value: null,
              });
            }
          }
        });
      }

    const CLIENT_LOADING_DELAY = 100;

    setTimeout(() => {
            if (
                StorageManager.getUser().rol.localeCompare('user') === 0 &&
                (environment.appName.localeCompare('pascualcabedo') === 0 ||
                    environment.appName.localeCompare('innovia') === 0)
            ) {
                const cliente =
                    this.clients.filtered[0]?.value ?? ({} as ClienteModel);

                this.clients.selected = cliente;

                if (cliente == null) {
                    this.updateClient();
                } else {
                    if (cliente.id == null) {
                        this.updateClient();
                    } else {
                        if (this.auxContador === 0) {
                            this.auxContador++;
                            this.updateClient();
                        }
                    }
                }
            } else {
                this.clients.filtered.unshift({
                    label: (environment.appName === 'detorres' ? 'TODAS LAS ' : 'TODOS LOS') + 
                    environment.features.clientesName.toUpperCase(),
                    value: null,
                });

                if (StorageManager.getClient()?.id !== this.clients.selected?.id) {
                    this.clients.selected = StorageManager.getClient();
                    this.updateClient();
                }
            }
            this.clientsService.clientesGET.safePerform();
        }, CLIENT_LOADING_DELAY);
  }

  private getModuleItem(): any {
    const modules = [
      {
        label: 'Albaranes',
        icon: 'bi bi-truck',
        command: (): void => {
          this.router.navigate(['dashboard/albaranes']);
        },
      },
    ];

    if (this.loginService.getCurrentUser().rol === 'admin') {
      modules.push(
        {
          label: 'Chofers',
          icon: 'bi bi-truck',
          command: (): void => {
            this.router.navigate(['dashboard/chofer']);
          },
        },
        {
          label: 'Clientes',
          icon: 'bi bi-person',
          command: (): void => {
            this.router.navigate(['dashboard/albaran-cliente']);
          },
        },
        {
          label: 'Maquinaria',
          icon: 'bi bi-tools',
          command: (): void => {
            this.router.navigate(['dashboard/albaran-maquinaria']);
          },
        },
        {
          label: 'Obras',
          icon: 'bi bi-cone',
          command: (): void => {
            this.router.navigate(['dashboard/obras']);
          },
        }
      );
    }

    return modules;
  }

  private initSyncDataCoop(): Promise<void> {
    this.iconRefresh = 'fa fa-refresh fa-spin';
    return firstValueFrom(
      this.http.get(environment.serverUrl + 'ws/sincro_inges/sincroniza.php')
    )
      .then((resp) => {
        console.log({ resp });

        alert('Se han actualizado los datos de clientes,fincas,parcelas');
        return;
      })
      .then(async () => {
        await firstValueFrom(
          this.http.get(
            environment.serverUrl +
            'ws/sincro_inges/tratamientos_fito_update.php'
          )
        );
        alert(
          'Se han actualizado los datos tareas fitosanitarias y tratamientos fitosanitarias'
        );
        this.iconRefresh = 'fa fa-refresh';
        return;
      })
      .catch(() => {
        console.log('Error en la conexión');
        this.iconRefresh = 'fa fa-refresh';
      });
  }

  private getVademecumActivity(): void {
    this.userActivityApi.vademecumActivityGET.safePerform();
    this.userActivityApi.vademecumActivityGET.response(
      (res: VademecumActivity[]) => {
        this.userActivity = res.reverse();
      }
    );
  }
      
  openDocumentInNewTab(): void {
    window.open('https://app.agrogest.com/#/register?estado=expired', '_blank');
  }
}
